export const COMPARISON_AUDIENCE_SUMMARY_LAYOUT_CONSTANTS = {
  LAYOUT_ID: 'comparison-audience-summary-layout',
  PLACEHOLDER_CARD_HEADING: 'Who is it best suited for?',
  PLACEHOLDER_CARD_BODY: 'Audience description text',
  PLACEHOLDER_SUMMARY: 'Summary paragraph text',
  DEFAULT_SUMMARY_HEADING: 'Summary',
  DEFAULT_TOPFAN_LABEL: 'TOPFAN',
  DEFAULT_ALT_LOGO: 'Brand logo'
} as const;
